/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/subscribeOn */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/operators/subscribeOn.mjs";
